// extracted by mini-css-extract-plugin
export default {"wrapper":"EditAboutForm_wrapper__iQu4u","submitWrapper":"EditAboutForm_submitWrapper__5A+na"};